<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">更新日期：</span>
                <a-range-picker @keydown.enter.native="searchKey" class="seachs" v-model="seach.update_time" :allowClear="false" :showTime="false"
                                format="YYYY-MM-DD"/>
            </div>
            <div class="seachList"><span class="name">颜色：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.a_template_color_id" class="seachs" allowClear @keydown.enter.native="searchKey"  >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.color_list">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">行业：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.a_ksh_industry_id" class="seachs" allowClear @keydown.enter.native="searchKey" >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.industry_list">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">编号：</span>
                <a-input placeholder=" " class="seachs" v-model="seach.code" @keydown.enter.native="searchKey" />
            </div>
            <div class="seachList"><span class="name">状态：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.status" class="seachs" allowClear @keydown.enter.native="searchKey" >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.status_list">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
          <div class="seachList"><span class="name">代理模板：</span>
            <a-select v-model="seach.is_proxy" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.proxy_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
          <div class="seachList"><span class="name">网站弹框：</span>
            <a-select v-model="seach.is_popup" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.popup_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
          <div class="seachList"><span class="name">导航类型：</span>
            <a-select v-model="seach.nav_type" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.nav_type_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
          <div class="seachList no"></div>
            <div class="seachBtnBox">
                <a-button type="primary" class="seachBtn" @click="getList(1)"> 查询</a-button>
                <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
        </div>
        <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加模板' ;this.editId=''; }"  >
            添加模板
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" > 排序</a-button>

        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"    :scroll="{ x: 1300 }">
          <span slot="template_url" slot-scope="text, record">
              <a :href="`${record.template_url}`" target="_blank">{{record.template_url}}</a>
            </span>
          <span slot="list_order" slot-scope="text, record">
              <a-input v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="thumb" slot-scope="text, record">
               <img src="../../../assets/tem2.png" alt="" @click="()=>{visibleImg=true;tableImg=record.picture}" style="width:30px;display: block;cursor: pointer">
            </span>
            <span slot="static_page" slot-scope="text, record">
              <a :href="`${urlBase}/${record.static_page.url}`" target="_blank">{{record.static_page.name}}</a>
            </span>
          <span slot="is_popup" slot-scope="text, record">
         <a-switch   @click="onChange(record)"  :checked="text==1?true:false"/>
            </span>
          <span slot="is_proxy" slot-scope="text, record">
         <a-switch   @click="onChangeProxy(record)"  :checked="text==1?true:false"/>
            </span>

            <span slot="action" slot-scope="text, record">
        <a
          @click="exportList(text.id)"
        >导出<a-divider  type="vertical"/></a>

              <a
          @click="()=>{
            goToKSH(record)
          }"
        >编辑<a-divider  type="vertical"/></a>
         <a @click="(record)=>{visible = true;; title='基本信息'; editId=text.id ; }" >基本信息<a-divider  type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a  >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <TemplateForm :visible="visible" :title="title" :editId="editId" @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>
        <IndexContent :visible="visibleIndex" :title="title" :editIds="editIds" @changVisible=" () => { this.editIds='';this.visibleIndex = false; this.getList()}  "/>
        <a-modal  :footer="null"
                  title="查看大图"
                :visible="visibleImg"
                @cancel="()=>{visibleImg=false}"
        >
            <img :src="tableImg" alt="" style="width: 100%;display: block">
        </a-modal>
    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import TemplateForm from "./components/templateForm"
    import IndexContent from "./components/indexContent"
    import {changStatus, removeById, orderList, createUrl} from "../../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "100px",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "编号",
            dataIndex: "code",
            width: "150px",
            ellipsis: true,
            key: "code"
        },
        {
            title: "缩略图",
            dataIndex: "thumb",
            ellipsis: true,
            width: "100px",
            key: "thumb",
            scopedSlots: {customRender: "thumb"}
        },
        {
            title: "模板地址",
            dataIndex: "template_url",
            ellipsis: true,
            width: "180px",
            scopedSlots: {customRender: "template_url"},
            key: "template_url"
        },
        {
            title: "客户数",
            dataIndex: "customer_num",
            ellipsis: true,
            width: "100px",
            key: "customer_num"
        },
        {
            title: "颜色",
            dataIndex: "color_name",
            ellipsis: true,
            width: "90px",
            key: "color_name"
        },
        {
            title: "行业",
            dataIndex: "industry_name",
            width: "150px",
            ellipsis: true,
            key: "industry_name"
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            width: "150px",
            ellipsis: true,
            key: "update_time"
        },

      {
        title: "代理模板",
        key: "is_proxy",
        width: "90px",
        dataIndex: "is_proxy",
        scopedSlots: {customRender: "is_proxy"}
      }, {
        title: "网站弹框",
        key: "is_popup",
        width: "90px",
        dataIndex: "is_popup",
        scopedSlots: {customRender: "is_popup"}
      },  {
        title: "导航类型",
        dataIndex: "nav_type_text",
        width: "90px",
        ellipsis: true,
        key: "nav_type_text"
      },

      {
            title: "状态",
            key: "status_text",
            width: "80px",
            dataIndex: "status_text",
            scopedSlots: {customRender: "status_text"}
        },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
              selectedRowKeys: [],
              urlBase:this.$store.state.urlExper,
                resetSeachdata:true,
                visibleImg:false,
                tableImg:"",
                seach: {
                  a_ksh_industry_id: undefined,
                  a_template_color_id: undefined,
                  code: "",
                  update_time: [],
                  status: undefined,
                  is_proxy:undefined,
                  is_popup:undefined,
                  nav_type:undefined
                },
                seachList: {
                  industry_list: [],
                  color_list: [],
                  status_list: [],
                  proxy_list:[],
                  popup_list:[],
                  nav_type_list:[]
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
                visible: false,
                visibleIndex:false,
                title: "",
                editId: null,
                editIds:null,
                jurisdictionId: null,
                visibleJurisdiction: false,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/kshTemplate/KshTemplateListManagement"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        components:{TemplateForm,IndexContent},
        methods: {
          createUrl,
          goToKSH(record){
            window.open(createUrl(record.ksh_token),'_blank')
          },
          onChangeProxy(row) {
            let Json = {id: row.id, is_proxy: row.is_proxy == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
          onChange(row) {
            let Json = {id: row.id, is_popup: row.is_popup == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS_PROXY, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
            searchKey(){
                if(event.keyCode == 13){
                    this.getList(1)
                }
            },
            indexCont(id){
                this.visibleIndex = true
                this.title='首页内容';
                setTimeout(() => { this.editIds= id ; }, 300)
            },
            confirm(row) {
                removeById(API.service.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },


            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                orderList(API.service.ORDER_LIST, list_orders).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {a_ksh_industry_id: undefined,
                  a_template_color_id: undefined,
                  code: "",
                  update_time: [],
                  status: undefined,
                  is_proxy:undefined,
                  is_popup:undefined,
                  nav_type:undefined
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
                    seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
                    seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.update_time=[]
                }
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.list.data
                    this.seachList.industry_list = res.data.data.industry_list
                    this.seachList.color_list = res.data.data.color_list
                    this.seachList.status_list = res.data.data.status_list
                    this.seachList.proxy_list = res.data.data.proxy_list
                    this.seachList.popup_list = res.data.data.popup_list
                    this.seachList.nav_type_list = res.data.data.nav_type_list
                  this.seachList.is_proxy = res.data.data.is_proxy

                    this.pagination.total=res.data.data.list.total
                    this.pagination.pageSize=res.data.data.list.per_page
                    this.pagination.current=res.data.data.list.current_page
                    if(!this.resetSeachdata==true)this.seach.update_time=[]
                    this.resetSeachdata=true
                    this.loading = false
                })
            },

          exper(id) {
            let seachData=JSON.parse(JSON.stringify(this.seach))


            if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
              seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
              seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
            }else{
              seachData.update_time=[]
            }
            API.service.EXPORT({...seachData,ids:this.selectedRowKeys}).then(res => {
              window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
              // this.getList()
              // this.selectedRowKeys = []
            })
          },
          onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
          },
          exportList(id){
            API.service.EXPORT({   id  }).then(res => {
              console.log("132res",res.data.data.file_url)
              window.open( `${this.$store.state.urlExper}${res.data.data.file_url}`  )
              // this.selectedRowKeys=[]
            })
          },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name{width: 70px!important;}
    .seachBox .seachList .seachs{width: calc(100% - 80px);}
    .seachBox .seachBtnBox{position: static;margin-top: 0;text-align: right;padding-right: 10px;}
</style>
